<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  catalog: { type: Object, default: () => ({ banks: [], pix_keys: [] }) },
  draft: { type: Object, required: true },
  isBank: { type: Boolean, default: false },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
const update = (field, event) => emit('update', field, event.target.value);
</script>

<template>
  <template v-if="isBank">
    <LaisField
      :label="t('REAL_ESTATE_BROKER_COMMISSION.DIALOG.BANK_NAME')"
      required
    >
      <select
        name="bank_code"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
        :value="draft.bank_code || ''"
        @change="update('bank_code', $event)"
      >
        <option value="">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED') }}
        </option>
        <option
          v-for="bank in catalog.banks || []"
          :key="bank.id"
          :value="bank.id"
        >
          {{ bank.name }}
        </option>
      </select>
    </LaisField>
    <div class="grid gap-4 sm:grid-cols-2">
      <LaisField
        :label="t('REAL_ESTATE_BROKER_COMMISSION.DIALOG.AGENCY')"
        required
      >
        <input
          name="branch"
          :value="draft.branch || ''"
          class="min-h-10 rounded-lais border border-lais-border px-3 text-sm"
          @input="update('branch', $event)"
        />
      </LaisField>
      <LaisField
        :label="t('REAL_ESTATE_BROKER_COMMISSION.DIALOG.ACCOUNT')"
        required
      >
        <input
          name="account_number"
          :value="draft.account_number || ''"
          class="min-h-10 rounded-lais border border-lais-border px-3 text-sm"
          @input="update('account_number', $event)"
        />
      </LaisField>
    </div>
  </template>
  <template v-else>
    <LaisField
      :label="t('REAL_ESTATE_BROKER_COMMISSION.DIALOG.PIX_KEY_TYPE')"
      required
    >
      <select
        name="pix_key_type"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
        :value="draft.pix_key_type || ''"
        @change="update('pix_key_type', $event)"
      >
        <option value="">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED') }}
        </option>
        <option
          v-for="key in catalog.pix_keys || []"
          :key="key.id"
          :value="key.id"
        >
          {{ key.name }}
        </option>
      </select>
    </LaisField>
    <LaisField
      :label="t('REAL_ESTATE_BROKER_COMMISSION.DIALOG.PIX_KEY')"
      required
    >
      <input
        name="pix_key"
        :value="draft.pix_key || ''"
        class="min-h-10 rounded-lais border border-lais-border px-3 text-sm"
        @input="update('pix_key', $event)"
      />
    </LaisField>
  </template>
</template>
